import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const GalleryToolbar = ({
  sites,
  selectedSite,
  onSiteChange,
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  totalCount,
  filteredCount,
}) => {
  const siteOptions = [
    { value: 'all', label: 'All Sites' },
    ...(sites?.map(s => ({ value: s?.id, label: s?.site_name })) || []),
  ];

  const sortOptions = [
    { value: 'upload_date_desc', label: 'Upload Date (Newest)' },
    { value: 'upload_date_asc', label: 'Upload Date (Oldest)' },
    { value: 'revision_desc', label: 'Revision (Latest First)' },
    { value: 'revision_asc', label: 'Revision (Oldest First)' },
    { value: 'name_asc', label: 'Name (A–Z)' },
    { value: 'name_desc', label: 'Name (Z–A)' },
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-2 mb-6">
      <div className="flex flex-col lg:flex-row gap-3">
        {/* Search */}
        <div className="relative flex-1">
          <Icon
            name="Search"
            size={16}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
          <Input
            type="text"
            placeholder="Search by drawing name or number…"
            value={searchQuery}
            onChange={e => onSearchChange(e?.target?.value)}
            className="pl-9"
          />
        </div>

        {/* Site filter */}
        <div className="w-full lg:w-52">
          <Select
            options={siteOptions}
            value={selectedSite}
            onChange={onSiteChange}
            placeholder="Filter by site"
          />
        </div>

        {/* Sort */}
        <div className="w-full lg:w-56">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={onSortChange}
            placeholder="Sort by"
          />
        </div>
      </div>

      {/* Result count */}
      {(searchQuery || selectedSite !== 'all') && (
        <p className="mt-3 text-xs text-muted-foreground">
          Showing <span className="font-semibold text-foreground">{filteredCount}</span> of{' '}
          <span className="font-semibold text-foreground">{totalCount}</span> drawings
        </p>
      )}
    </div>
  );
};

export default GalleryToolbar;
